export default "__VITE_ASSET__tyGM$UHY__"